import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

function VendorRegUser() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    business_name: "",
    contact_name: "",
    email: "",
    phone: "",
    address: "",
    craft_type: "Handloom Weaving",
    story: "",
    experience: "1"
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.business_name || !formData.email || !formData.phone) {
      toast.error("Please fill in all mandatory fields.");
      return;
    }

    toast.success("Application Submitted Successfully! Our curation board will contact you in 48 hours.", {
      position: "top-center",
      autoClose: 5000,
      onClose: () => navigate("/")
    });
  };

  return (
    <>
      <ToastContainer />
      <PortalContainer>
        {/* Banner Section */}
        <BannerSection>
          <div className="overlay" />
          <BannerContent>
            <span className="badge">PARTNER WITH KERALASPECIAL</span>
            <h2>Onboard Your Craft to Global Connoisseurs</h2>
            <p>
              Join Kerala's premier luxury marketplace. We bridge local cooperative societies,
              traditional weavers, spice cooperatives, and master craftsmen directly with millions of premium consumers worldwide.
            </p>
          </BannerContent>
        </BannerSection>

        {/* Core Pillars */}
        <PillarsSection>
          <div className="section-title">
            <span>Why Join Us?</span>
            <h3>Empowering Kerala's Rich Heritage</h3>
          </div>
          <PillarsGrid>
            <PillarCard>
              <div className="icon-box"><Icon icon="mdi:globe" /></div>
              <h4>Global Footprint</h4>
              <p>Showcase and sell your handcrafted products to customers in North America, Europe, UAE, and beyond.</p>
            </PillarCard>
            <PillarCard>
              <div className="icon-box"><Icon icon="mdi:handshake" /></div>
              <h4>Fair Trade &amp; Integrity</h4>
              <p>Enjoy direct sourcing payouts, absolute pricing transparency, and zero hidden mediator fees.</p>
            </PillarCard>
            <PillarCard>
              <div className="icon-box"><Icon icon="mdi:shield-check" /></div>
              <h4>Curation &amp; Branding</h4>
              <p>Benefit from premium cataloging, cinematic storytelling, and digital brand elevation campaigns.</p>
            </PillarCard>
          </PillarsGrid>
        </PillarsSection>

        {/* Form Card */}
        <FormSection>
          <FormCard>
            <div className="form-header">
              <h3>Apply for Artisan Partnership</h3>
              <p>Submit your cooperative or workshop details. Our heritage curators will review your craft credentials.</p>
            </div>

            <form onSubmit={handleSubmit}>
              <FormGroup>
                <label>Artisan Workshop / Society Name <span className="req">*</span></label>
                <input
                  type="text"
                  required
                  placeholder="e.g. Wayanad Organic Cardamom Growers"
                  value={formData.business_name}
                  onChange={(e) => setFormData({ ...formData, business_name: e.target.value })}
                />
              </FormGroup>

              <FormGroup>
                <label>Primary Representative Name <span className="req">*</span></label>
                <input
                  type="text"
                  required
                  placeholder="e.g. K. Raghavan Pillai"
                  value={formData.contact_name}
                  onChange={(e) => setFormData({ ...formData, contact_name: e.target.value })}
                />
              </FormGroup>

              <FormRow>
                <FormGroup>
                  <label>Business Email Address <span className="req">*</span></label>
                  <input
                    type="email"
                    required
                    placeholder="e.g. raghavan@wayanadgrowers.in"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  />
                </FormGroup>

                <FormGroup>
                  <label>Contact Mobile Number <span className="req">*</span></label>
                  <input
                    type="text"
                    required
                    placeholder="e.g. +91 98450 11223"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  />
                </FormGroup>
              </FormRow>

              <FormRow>
                <FormGroup>
                  <label>Primary Craft/Product Type</label>
                  <select
                    value={formData.craft_type}
                    onChange={(e) => setFormData({ ...formData, craft_type: e.target.value })}
                  >
                    <option value="Handloom Weaving">Traditional Handloom Weaving</option>
                    <option value="Ayurvedic Formulas">Ayurvedic Herbals &amp; Oils</option>
                    <option value="Single-Origin Spices">Single-Origin Spices</option>
                    <option value="Traditional Snacks">Kerala Savory &amp; Snacks</option>
                    <option value="Wood/Metal Handcrafts">Aranmula Mirror / Metalcraft</option>
                  </select>
                </FormGroup>

                <FormGroup>
                  <label>Years of Heritage Experience</label>
                  <select
                    value={formData.experience}
                    onChange={(e) => setFormData({ ...formData, experience: e.target.value })}
                  >
                    <option value="1">1 to 5 Years</option>
                    <option value="2">5 to 10 Years</option>
                    <option value="3">Over 10 Years (Traditional Legacy)</option>
                  </select>
                </FormGroup>
              </FormRow>

              <FormGroup>
                <label>Business Address / Workshop Location</label>
                <textarea
                  rows={2}
                  placeholder="e.g. Sultan Bathery, Wayanad, Kerala 673592"
                  value={formData.address}
                  onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                />
              </FormGroup>

              <FormGroup>
                <label>Share Your Craft's Story (Optional)</label>
                <textarea
                  rows={3}
                  placeholder="Tell us about the weavers, organic growers, or traditions behind your brand..."
                  value={formData.story}
                  onChange={(e) => setFormData({ ...formData, story: e.target.value })}
                />
              </FormGroup>

              <SubmitBtn type="submit">
                <span>Submit Partnership Request</span>
                <Icon icon="mdi:arrow-right" />
              </SubmitBtn>
            </form>
          </FormCard>
        </FormSection>
      </PortalContainer>
    </>
  );
}

// Styled Components
const PortalContainer = styled.div`
  background: #FDFBF7;
  min-height: 100vh;
  font-family: "Jost", sans-serif;
  margin-top: 110px; /* Clear header */
  padding-bottom: 60px;
`;

const BannerSection = styled.section`
  position: relative;
  background-image: url("https://images.unsplash.com/photo-1590001155093-a3c66ab0c3ff?auto=format&fit=crop&q=80&w=1500");
  background-size: cover;
  background-position: center;
  padding: 80px 20px;
  text-align: center;
  color: #FDFBF7;

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(18, 53, 36, 0.85); /* Dark Emerald Mask */
    z-index: 1;
  }
`;

const BannerContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;

  .badge {
    display: inline-block;
    padding: 6px 14px;
    background: rgba(212, 175, 55, 0.15);
    border: 1px solid rgba(212, 175, 55, 0.3);
    color: #D4AF37;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.15em;
    border-radius: 30px;
    text-transform: uppercase;
    margin-bottom: 20px;
  }

  h2 {
    font-family: "Playfair Display", serif;
    font-size: 38px;
    font-weight: 700;
    margin: 0 0 20px 0;
    color: #FDFBF7;
    line-height: 1.3;

    @media (max-width: 768px) {
      font-size: 28px;
    }
  }

  p {
    font-size: 16px;
    line-height: 1.6;
    color: #F2ECE1;
    opacity: 0.9;
    margin: 0;
  }
`;

const PillarsSection = styled.section`
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;

  .section-title {
    text-align: center;
    margin-bottom: 40px;

    span {
      font-size: 13px;
      font-weight: 600;
      color: #c5a880;
      text-transform: uppercase;
      letter-spacing: 0.1em;
    }

    h3 {
      font-family: "Playfair Display", serif;
      font-size: 28px;
      font-weight: 700;
      color: #123524;
      margin: 5px 0 0;
    }
  }
`;

const PillarsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const PillarCard = styled.div`
  background: #FFFFFF;
  border: 1px solid rgba(197, 168, 128, 0.15);
  border-radius: 16px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(45, 31, 24, 0.02);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 30px rgba(197, 168, 128, 0.1);
    border-color: #D4AF37;
  }

  .icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: rgba(18, 53, 36, 0.06);
    color: #123524;
    font-size: 28px;
    margin: 0 auto 20px;
  }

  h4 {
    font-family: "Playfair Display", serif;
    font-size: 18px;
    color: #123524;
    margin: 0 0 10px 0;
    font-weight: 700;
  }

  p {
    font-size: 13.5px;
    color: #666;
    line-height: 1.6;
    margin: 0;
  }
`;

const FormSection = styled.section`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FormCard = styled.div`
  background: #FFFFFF;
  border: 1px solid rgba(197, 168, 128, 0.15);
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(45, 31, 24, 0.03);

  .form-header {
    border-bottom: 1px dashed rgba(197, 168, 128, 0.20);
    padding-bottom: 20px;
    margin-bottom: 30px;

    h3 {
      font-family: "Playfair Display", serif;
      font-size: 24px;
      font-weight: 700;
      color: #123524;
      margin: 0 0 8px 0;
    }

    p {
      font-size: 14px;
      color: #666;
      margin: 0;
    }
  }

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  label {
    font-size: 13px;
    font-weight: 600;
    color: #2D1F18;
    margin-bottom: 8px;

    .req {
      color: #dc3545;
    }
  }

  input, select, textarea {
    padding: 12px 16px;
    border: 1px solid rgba(197, 168, 128, 0.3);
    border-radius: 8px;
    background: #FFF;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    color: #2D1F18;
    transition: all 0.3s ease;

    &:focus {
      outline: none;
      border-color: #123524;
      box-shadow: 0 4px 12px rgba(18, 53, 36, 0.05);
    }
  }

  textarea {
    resize: none;
  }
`;

const SubmitBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 54px;
  background: linear-gradient(135deg, #123524 0%, #0d261a 100%);
  color: #FDFBF7;
  border: none;
  border-radius: 50px;
  font-family: "Jost", sans-serif;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(18, 53, 36, 0.15);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  margin-top: 15px;

  &:hover {
    background: linear-gradient(135deg, #D4AF37 0%, #C5A880 100%);
    color: #123524;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(197, 168, 128, 0.25);
  }

  svg {
    font-size: 18px;
  }
`;

export default VendorRegUser;
